// Utility functions for consistent styling across components
import { twMerge } from "tailwind-merge";

// Layout utilities
export const containerMain = "mx-auto max-w-[85rem] px-8";
export const pageHeader = "relative w-full border-b border-b-black bg-gray-200 py-2";
export const pageHeaderContent = "mx-auto max-w-[85rem]";

// Typography utilities
export const pageTitle = "text-center font-serif text-[110%] font-bold italic md:text-xl";
export const sectionHeading = "my-2 font-serif text-2xl font-bold italic text-(--darkred)";
export const sectionHeadingLarge = "my-2 font-serif text-3xl font-bold italic text-(--darkred)";
export const subsectionHeading = "my-2 font-serif text-xl font-bold italic";
export const textBody = "my-2";
export const textBodyJustify = "my-2 text-justify";

// Link utilities
export const linkPrimary = "text-(--themered) hover:text-(--darkred) hover:underline";
export const linkButton = "my-2 block w-48 rounded-full border border-(--themered) p-2 px-4 text-center font-bold text-(--themered) hover:text-(--darkred) hover:border-(--darkred) hover:underline";

// Navigation utilities
export const navLinkBase = "flex items-center rounded-lg px-2 py-2 text-xl font-semibold leading-6 text-white/80 hover:bg-(--dark) hover:text-white";
export const navLinkMobile = "rounded-lg p-2 text-right text-lg font-semibold leading-6 text-white/80 hover:bg-(--dark) hover:text-white";

// List utilities
export const listDiscIndented = "ml-8 list-disc";
export const listDiscSmall = "ml-6 list-disc";

// Form utilities
export const selectStyled = "my-2 block rounded-lg border-2 border-gray-500 px-4 py-3 pe-9 text-xl focus:border-(--red) focus:ring-(--red) md:text-base";

// Contact info utilities
export const contactItem = "flex items-center space-x-2";
export const contactIcon = "size-5 text-(--darkred) md:size-6";

// Card/Section utilities
export const examSection = "mb-6 ml-4";

// Mobile menu utilities
export const mobileMenuPanel = "fixed inset-y-0 right-0 z-10 w-full overflow-y-auto bg-gradient-to-b from-(--darkdarkred) to-(--darkred) px-6 py-6 lg:max-w-sm lg:ring-1 lg:ring-gray-900/10";
export const mobileMenuContent = "flex flex-col items-end space-y-2 py-6";

// Utility function to create nav link classes with active state
export const createNavLinkClasses = (isActive: boolean, baseClasses = navLinkBase) =>
  twMerge(baseClasses, isActive ? "text-white" : "text-white/80");

// Utility function for responsive container
export const responsiveContainer = (additionalClasses = "") =>
  twMerge(containerMain, additionalClasses);